







import { defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";

export default defineComponent({
  name: "BaseBadge",
  props: {
    text: { type: String as PropType<TranslateResult>, default: "" },
  },
});
